<template>
  <div class="navbar-container">
    <nav class="navbar">
      <div class="nav-left">
        <!-- Logo -->
        <router-link to="/" class="logo">
          <img :src="logoImage" alt="Logo" />
        </router-link>

        <!-- Navigation Links (hidden on small screens) -->
        <div class="nav-links" v-if="!isMobile">
          <router-link to="/proDesc">SaaS 解决方案</router-link>
          <!-- <div v-for="item in navItems" :key="item.id" class="sidebar-item">
            <router-link v-if="item.unfold == '1' && item.show_sort==1" to="/" @click="toggleSidebar">{{ item.name }}</router-link>
            <router-link v-if="item.unfold == '1' && item.show_sort==2" to="/" @click="goToHomeAndScroll('new_features')">{{ item.name }}</router-link>
            <router-link v-if="item.unfold == '1' && item.show_sort==3" to="/" @click="goToHomeAndScroll('application_scenarios')">{{ item.name }}</router-link>
            <router-link v-else-if="item.unfold == '1' && (item.show_sort!=2 && item.show_sort!=3)" :to="getHref(item.href)" @click="toggleSidebar">{{ item.name }}</router-link>
          </div> -->
          <router-link to="/smart">商用硬件</router-link>
          <!-- <div 
            class="dropdown hover-dropdown"
            @mouseenter="showHardwareMenu = true"
            @mouseleave="showHardwareMenu = false"
          >
            <div class="dropdown-trigger">
              商用硬件
            </div>
            
            <div class="dropdown-menu syyj-dropdown-menu" v-show="showHardwareMenu">
              <router-link to="/hardware/commercial">商用硬件设备</router-link>
              <router-link to="/hardware/smart">智能经营设备</router-link>
            </div>
          </div> -->
          <a href="/#new_features" class="new_features" rel="nofollow">全新功能</a>
          <a href="/#application_scenarios" class="application_scenarios" rel="nofollow">应用场景</a>
          <!-- <router-link to="/about">关于我们</router-link> -->
          
          <router-link to="/toAgentRegister">服务商加盟</router-link>
          <a href="/toRegister" class="contact-link">联系我们</a>
          <a class="dropdown" @mouseover="showDropdown = true" 
          @mouseleave="showDropdown = false">
            <div class="more">更多</div>
            <div class="dropdown-menu" v-if="showDropdown">
              <router-link to="/about" class="dropdown-item">九点半品牌介绍</router-link>
              <router-link to="/list" class="dropdown-item">九点半资讯动态</router-link>
            </div>
          </a>
        </div>
      </div>

      <div class="nav-right">
        <!-- Language and Login Icons (visible on small screens) -->
        <div class="icon-group" v-if="isMobile">
          <!-- <div class="dropdown click-dropdown" ref="languageDropdown">
            <div class="dropdown-trigger" @click.stop="toggleLanguageMenu" style="padding: 5px 12px;">
              <img src="@/assets/images/language.png" alt="Language" class="icon" />
            </div>
            <div class="dropdown-menu" v-show="showLanguageMenu" style="width: 90px;">
              <div 
                class="dropdown-item" 
                @click="changeLanguage('zh')"
                :class="{ active: currentLanguage === '简体中文' }"
              >
                简体中文
              </div>
              <div 
                class="dropdown-item" 
                @click="changeLanguage('en')"
                :class="{ active: currentLanguage === 'English' }"
              >
                English
              </div>
            </div>
          </div> -->
          <!-- <img src="@/assets/images/language.png" alt="Language" class="icon" @click.stop="toggleLanguageMenu"/> -->
        
          <img v-if="!isMobile" src="@/assets/images/login.png" alt="Login" class="icon" />
          <router-link to="/toRegister" class="free-trial">免费试用</router-link>
        </div>

        <!-- Language and Login with Text (visible on large screens) -->
        <div class="language-login" v-else>
          <!-- <div class="dropdown click-dropdown" ref="languageDropdown">
            <div class="dropdown-trigger" @click.stop="toggleLanguageMenu">
              <img src="@/assets/images/language.png" alt="Language" class="icon" />
              {{ currentLanguage }}
            </div>
            <div class="dropdown-menu" v-show="showLanguageMenu">
              <div 
                class="dropdown-item" 
                @click="changeLanguage('zh')"
                :class="{ active: currentLanguage === '简体中文' }"
              >
                简体中文
              </div>
              <div 
                class="dropdown-item" 
                @click="changeLanguage('en')"
                :class="{ active: currentLanguage === 'English' }"
              >
                English
              </div>
            </div>
          </div> -->
          <a class="login-link" @click="handleLogin" href="https://app.930pm.cn/#/login" rel="nofollow">
            <img src="@/assets/images/loginlogo.png" alt="Login" class="icon" />
            系统登录
          </a>
        </div>

        <!-- Hamburger Menu Icon (visible on small screens) -->
        <div class="hamburger-menu" @click="toggleSidebar" v-if="isMobile">
          <img src="@/assets/images/icons7.png" alt="Menu" />
        </div>
      </div>

      <!-- Sidebar (visible on small screens) -->
      <div class="sidebar-overlay" v-show="showSidebar" @click="toggleSidebar"></div>
      <div class="sidebar" :class="{ 'sidebar-visible': showSidebar }">
        <div class="sidebar-content">
          <!-- <div class="sidebar-item"> -->
            <router-link to="/" @click="toggleSidebar">首页</router-link>
          <!-- </div> -->
          <router-link to="/proDesc" @click="toggleSidebar">SaaS_解决方案</router-link>
          <!-- <div v-for="item in navItems" :key="item.id" class="sidebar-item">
            <router-link v-if="item.unfold == '1' && item.show_sort==2" to="/" @click="goToHomeAndScroll('new_features')">{{ item.name }}</router-link>
            <router-link v-if="item.unfold == '1' && item.show_sort==3" to="/" @click="goToHomeAndScroll('application_scenarios')">{{ item.name }}</router-link>
            <router-link v-else-if="item.unfold == '1' && (item.show_sort!=2 && item.show_sort!=3)" :to="getHref(item.href)" @click="toggleSidebar">{{ item.name }}</router-link>
          </div> -->
          <router-link to="/smart" @click="toggleSidebar">商用硬件</router-link>
          <!-- <div class="accordion-item">
            <div class="accordion-trigger" @click="toggleAccordion">
              商用硬件
            </div>
            <div class="accordion-content" v-show="showAccordion">
              <router-link to="/hardware/commercial" @click="toggleSidebar">商用硬件设备</router-link>
              <router-link to="/hardware/smart" @click="toggleSidebar">智能经营设备</router-link>
            </div>
          </div> -->
          <a href="/#new_features" class="new_features" rel="nofollow">全新功能</a>
          <a href="/#application_scenarios" class="application_scenarios" rel="nofollow">应用场景</a>
          <!-- <router-link to="/" @click="goToHomeAndScroll('new_features')">全新功能</router-link>
          <router-link to="/" @click="goToHomeAndScroll('application_scenarios')">应用场景</router-link> -->
          <!-- <router-link to="/about" @click="toggleSidebar">更多</router-link> -->
          
          <router-link to="/toAgentRegister" @click="toggleSidebar">服务商加盟</router-link>
          <router-link to="/toRegister" @click="toggleSidebar">联系我们</router-link>
          <a class="dropdown" @click="toggleAccordion" >
            <div class="more accordion-trigger">更多</div>
            <div class="accordion-content" v-show="showAccordion">
              <router-link to="/about" class="dropdown-item" @click="toggleSidebar">九点半品牌介绍</router-link>
              <router-link to="/list" class="dropdown-item" @click="toggleSidebar">九点半资讯动态</router-link>
            </div>
          </a>
          <!-- 渲染从接口获取的可替换项 -->
        <div >
      </div>
      </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import { ref, onMounted, onUnmounted, nextTick } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { homeApi } from '@/api/home';
  import { imagePath } from '@/utils/imagePath';
  import logoImage from '@/assets/images/logo.png';
  export default {
    data() {
      return {
        logoImage: logoImage,
      };
    },
    setup() {
      const showHardwareMenu = ref(false);
      const showSidebar = ref(false);
      const showAccordion = ref(false);
      const showLanguageMenu = ref(false);
      const currentLanguage = ref('简体中文');
      const showDropdown = ref(false);
      const isshowDropdown = ref(false);
      const isMobile = ref(window.innerWidth < 1024);
      const navItems = ref([]); // 用于存储导航数据
      
      // 使用Vue Router的useRoute和useRouter钩子
      const route = useRoute();
      const router = useRouter();
  
      // 免费试用
      const handleClick = () => {
        router.push('/toRegister');
      };
  
      const dataLoaded = ref(false);
      const toggleDropdown = () => {
        console.log('toggleDropdown',showDropdown.value);
        isshowDropdown.value = !isshowDropdown.value;
      };

  
      // 跳转至首页并滚动到指定锚点
      const goToHomeAndScroll = (anchor) => {
        showSidebar.value = false; // 关闭弹框
        if (route.name === 'home') {
          console.log('是首页');
          // 如果当前是首页，直接滚动到锚点
          const element = document.getElementById(anchor);
          if (element) {
            scrollToAnchor(anchor);
          }
        } else {
          console.log('不是首页');
          // 如果不是首页，先跳转至首页
          router.push({ name: 'home' }).then(() => {
            // 使用 nextTick 确保 DOM 更新完成后再滚动
            nextTick(() => {
              setTimeout(() => {
                scrollToAnchor(anchor);
              }, 1000);
            });
          });
        }
      };
      // 获取导航数据
      const getNav = async () => {
        try {
          const response = await homeApi.getNav(); // 调用接口
          navItems.value = response.data; // 假设返回的数据在 response.data 中
          navItems.value.sort((a, b) => a.show_sort - b.show_sort);
        } catch (error) {
          console.error('获取导航数据失败:', error);
        }
      };
      const getHref = (href) => {
      // 去掉前缀
      return href.replace('https://gw.930pm.cn/#/', '');
    };
      // 滚动到指定锚点
      const scrollToAnchor = (anchor) => {
        const element = document.getElementById(anchor);
        if (element) {
          const rect = element.getBoundingClientRect();
          window.scrollTo({
            top: rect.top + window.scrollY - 50, // 锚点定位后再加50px
            behavior: 'smooth'
          });
        }
      };
  
      // 切换硬件菜单
      const toggleHardwareMenu = () => {
        showHardwareMenu.value = !showHardwareMenu.value;
      };
  
      // 切换侧边栏
      const toggleSidebar = () => {
        showSidebar.value = !showSidebar.value;
        showAccordion.value = false;
      };
  
      // 切换风琴菜单
      const toggleAccordion = () => {
        showAccordion.value = !showAccordion.value;
      };
  
      // 切换语言菜单
      const toggleLanguageMenu = () => {
        showLanguageMenu.value = !showLanguageMenu.value;
      };
  
      // 切换语言
      const changeLanguage = (lang) => {
        currentLanguage.value = lang === 'zh' ? '简体中文' : 'English';
        showLanguageMenu.value = false;
      };
  
      // 监听窗口大小变化
      const handleResize = () => {
        isMobile.value = window.innerWidth < 1024;
      };
  
      // 处理点击外部关闭语言菜单
      const handleClickOutside = (event) => {
        if (!event.target.closest('.click-dropdown')) {
          showLanguageMenu.value = false;
        }
      };
  
      onMounted(() => {
        getNav();
        window.addEventListener('resize', handleResize);
        document.addEventListener('click', handleClickOutside);
      });
  
      onUnmounted(() => {
        window.removeEventListener('resize', handleResize);
        document.removeEventListener('click', handleClickOutside);
      });
  
      return {
        showHardwareMenu,
        showSidebar,
        showAccordion,
        showLanguageMenu,
        currentLanguage,
        isMobile,
        navItems,
        showDropdown,
        isshowDropdown,
        getHref,
        handleClick,
        goToHomeAndScroll,
        toggleHardwareMenu,
        toggleSidebar,
        toggleDropdown, 
        toggleAccordion,
        toggleLanguageMenu,
        changeLanguage
      };
    }
  };
  </script>

<style scoped>
  a:hover{
    background-color: transparent;
  }
.navbar-container{
  width: 100%;
  /* background-color: #00000090; */
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  height: 54px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: url('@/assets/images/navbarbg.png') no-repeat;
  background-size: 100% 100%;
  opacity: 0.99;
}
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 0 15px; *//* 减少 padding */
  height: 54px;
  width: 1366px;
  max-width: 1680px;
  color: #fff;
 margin: 0 auto;
}

.nav-left, .nav-right {
  display: flex;
  align-items: center;
 
}
.logo img {
  height: 28px;
  margin-right: 40px;
  margin-top: 10px;
}

.nav-links {
  display: flex;
  gap: 1rem;
}

.nav-links a {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  padding: 16px 12px;
  white-space: nowrap;
}

.nav-links a:hover {
  color: #1890ff;
}

.nav-links a.router-link-active {
  color: #1890ff;
}
.nav-links .new_features.router-link-active {
  color: #fff;
}
.nav-links .application_scenarios.router-link-active {
  color: #fff;
}
.nav-links .new_features:hover {
  color: #1890ff;
}
.nav-links .application_scenarios:hover {
  color: #1890ff;
}
.nav-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.icon-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.icon {
  width: 16px;
  height: 16px;
  margin-top: -5px;
  margin-right: 5px;
  cursor: pointer;
}

.language-login {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.dropdown {
  position: relative; /* 确保下拉菜单相对于触发器定位 */
}
.dropdown-trigger, .login-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #fff;
  padding: 16px 12px;
  transition: color 0.3s;
}

/* .dropdown-trigger:hover, .login-link:hover {
  color: #1890ff;
} */
.language-login .dropdown-trigger, .login-link {
  padding: 5px 12px;
  padding-right: 0;
}

.dropdown-menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 52px;
  background: url('@/assets/images/navbarbg.png') no-repeat;
  background-size: 100% 100%;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.dropdown-menu[v-show="true"] {
  display: block; /* 显示时设置为块级元素 */
}
.dropdown-menu a{
  color: #fff;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.language-login .dropdown-menu{
  left: 20px;
  width: 100px;
}
.syyj-dropdown-menu a{
  padding: 8px 12px;
}

/* .dropdown-item:hover {
  color: #1890ff;
} */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  transition: opacity 0.3s ease;
}

.sidebar {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  background-color: #000;
  box-shadow: -2px 0 8px rgba(0,0,0,0.1);
  z-index: 1001;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: #fff;
  transform: translateX(100%); /* 初始位置在视口外 */
  transition: transform 0.3s ease; /* 添加过渡效果 */
}
.sidebar-visible {
  transform: translateX(0); /* 显示时滑入视口 */
}

.sidebar-content {
  display: flex;
  flex-direction: column;
}

.sidebar-link {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  padding: 8px 0;
  transition: color 0.3s;
  border-bottom: 1px solid #333; /* 添加底部边框 */
}
.sidebar-link:hover {
  color: #1890ff;
}
.accordion-trigger {
  color: #fff;
  cursor: pointer;
  padding: 8px 0;
}
.accordion-content {
  display: flex;
  flex-direction: column; /* 确保二级菜单项垂直排列 */
  transition: opacity 0.3s ease;
}

.sidebar-content a,
.accordion-trigger {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  padding: 8px 0;
  transition: color 0.3s;
  cursor: pointer;
}

.sidebar-content a:hover,
.accordion-trigger:hover {
  color: #1890ff;
}
.free-trial{
margin-right: 10px;
text-decoration: underline;
cursor: pointer;
}
.sidebar-item{padding: 8px 0;}
.dropdown {
  position: relative;
  display: inline-block;
}

/* .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
} */
.more{
  cursor: pointer;
}

/* 平板样式 */
@media (min-width: 768px) and (max-width: 1023px) {
  .navbar{
    width: 90%;
  }
  .nav-links {
    display: none;
  }
  .hamburger-menu {
    display: block;
  }
  .hamburger-menu img{
   width: 28px;
   height: 28px;
   margin-top: 6px;
  }
  .sidebar {
    width: 220px; 
  }
  .dropdown-menu {
    left: -10px;
    top: 36px;
}

.dropdown-menu[v-show="true"] {
  display: block; /* 显示时设置为块级元素 */
}
.nav-links .dropdown-menu a{
  padding: 0 12px;
  height: 37px;
  line-height: 37px;
}
}
@media (min-width: 1024px) and (max-width: 1366px) {
  .navbar{
    width: 90%;
  }
  .nav-left{
    width: 80%;
  }
  .nav-links{
    gap: 2rem;
  }
  .nav-links a{
    /* display: none; */
    padding: 0;
    height: 54px;
    line-height: 54px;
  }
  .hamburger-menu {
    display: block;
  }
  .hamburger-menu img{
   width: 28px;
   height: 28px;
   margin-top: 6px;
  }
  .dropdown-menu {
    left: -12px;
    top: 52px;
  }
  .dropdown-menu[v-show="true"] {
    display: block; /* 显示时设置为块级元素 */
  }
  .nav-links .dropdown-menu a{
    padding: 0 12px;
    height: 37px;
    line-height: 37px;
  }
}
@media (min-width: 1024px) and (max-width: 1120px) {
  .nav-links{
    gap: 1.2rem;
  }
  .dropdown-menu {
    left: -12px;
    top: 52px;
  }

  .dropdown-menu[v-show="true"] {
    display: block; /* 显示时设置为块级元素 */
  }
  .nav-links .dropdown-menu a{
    padding: 0 12px;
    height: 37px;
    line-height: 37px;
  }
}
/* 移动端样式 */
@media (max-width: 767px) {
  .navbar{
    width: 90vw;
  }
  .navbar-container{
    background-color: #000;
  }
  .hamburger-menu {
    display: block;
  }
  .hamburger-menu img{
   width: 28px;
   height: 28px;
   margin-top: 6px;
  }
  .dropdown-menu{
    position:static ;
  }
  .accordion-trigger{
    padding: 0;
  }
}
</style>